import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=69e8eeb6&"
import script from "./Insight.vue?vue&type=script&lang=js&"
export * from "./Insight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports